import * as React from 'react';
import { Provider } from 'mobx-react';
import { ContentCreatorStore } from './stores';
import { IInstance } from '../../interfaces/IInstance';
import { IUser } from '../../interfaces/IUser';
import { ContentCreatorAdmin } from './ContentCreatorAdmin';
import ContentCreatorService from '../../services/ContentCreatorService';
import { IContentCreator } from '../../interfaces/IContentCreator';

export interface IProps {
  tenant: string;
  instance: IInstance;
  token: string;
  environment: "Development" | "Test" | "Production";
  isMobile: boolean;
  marginTop: number;
  user: IUser;
  highlightColor: string;
}

export class IAContentCreatorAdmin extends React.Component<IProps> {

  private contentCreatorStore: ContentCreatorStore;

  constructor(props: IProps) {
    super(props);

    

    this.contentCreatorStore = new ContentCreatorStore();
    this.contentCreatorStore.tenant = props.tenant;
    this.contentCreatorStore.instance = props.instance;
    this.contentCreatorStore.token = props.token;
    this.contentCreatorStore.environment = props.environment;
    this.contentCreatorStore.isMobile = props.isMobile;
    this.contentCreatorStore.marginTop = props.marginTop;
    this.contentCreatorStore.user = props.user;
    this.contentCreatorStore.highlightColor = props.highlightColor;
    this.contentCreatorStore.loading = true;
    this.get();
  }

  public componentWillReceiveProps(props: IProps) {
    if (props != this.props) {
      this.contentCreatorStore.tenant = props.tenant;
      this.contentCreatorStore.instance = props.instance;
      this.contentCreatorStore.token = props.token;
      this.contentCreatorStore.environment = props.environment;
      this.contentCreatorStore.isMobile = props.isMobile;
      this.contentCreatorStore.marginTop = props.marginTop;
      this.contentCreatorStore.user = props.user;
      this.contentCreatorStore.highlightColor = props.highlightColor;
      if (props.instance !== this.props.instance) {
        this.get();
      }
    }
  }

  private get(): void {
    ContentCreatorService.get(this.contentCreatorStore.environment, this.contentCreatorStore.token, this.contentCreatorStore.tenant, this.contentCreatorStore.instance.instanceName).then((contentCreator: IContentCreator) => {
      this.contentCreatorStore.id = contentCreator.id;
      this.contentCreatorStore.title = contentCreator.title;
      this.contentCreatorStore.items = contentCreator.config;
      this.contentCreatorStore.loading = false;
    });
  }

  render() {
    return (
      <Provider contentCreatorStore={this.contentCreatorStore}>
        <ContentCreatorAdmin />
      </Provider>
    )
  }
}